import { render, staticRenderFns } from "./LegoLogo.vue?vue&type=template&id=df516dc8&"
import script from "./LegoLogo.vue?vue&type=script&lang=ts&"
export * from "./LegoLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports